module.exports = __webpack_public_path__ + "23d690a92667af67604cb65231e5fb03.webp";